import comp from "./StandardSetsTable";
export default comp;
